import { DEFAULT_LANGUAGE, Language } from "@models/language";
import {
  FieldErrors,
  FieldValues,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
import DynamicFormField from "./DynamicFormField";
import { Field } from "./types";

const DynamicForm = ({
  cols: cols = 2,
  fields,
  errors,
  register,
  handleSubmit,
  setValue,
  language: language = DEFAULT_LANGUAGE,
  isDirty: isDirty = true,
}: {
  cols?: number;
  fields: Field[];
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
  handleSubmit: UseFormHandleSubmit<FieldValues>;
  language?: Language;
  isDirty?: boolean;
  setValue?: UseFormSetValue<FieldValues>;
}) => {
  const _onSubmit = (values) => {
    console.log(values, errors);
    return values;
  };

  // https://tailwindcss.com/docs/content-configuration#dynamic-class-names
  let columns = "sm:grid-cols-2";
  switch (cols) {
    case 1:
      columns = "sm:grid-cols-1";
      break;
    case 2:
      columns = "sm:grid-cols-2";
      break;
    case 3:
      columns = "sm:grid-cols-3";
      break;
    case 4:
      columns = "sm:grid-cols-4";
      break;
  }

  return (
    <form
      className={"grid gap-6 grid-cols-1 sm:p-3 " + columns}
      onSubmit={handleSubmit(_onSubmit)}
    >
      {fields.map((field, i) => (
        <DynamicFormField
          key={i}
          field={field}
          errors={errors}
          register={register}
          language={language}
          isDirty={isDirty}
          setValue={setValue}
        />
      ))}
    </form>
  );
};

export default DynamicForm;
